import React, { useState } from 'react';
import Button from 'reactstrap/lib/Button';
import Input from 'reactstrap/lib/Input';
import InputGroup from 'reactstrap/lib/InputGroup';

export const Postcode = ({ personName, submitPostCode, validationType, isStaff }) => {
    const [tempPostCode, setTempPostCode] = useState("");

    return <div className="text-white">
        <p>The Link you provided is unique to <strong>{personName}</strong> and can only be used once to book an appointment for yourself.</p>

        <p>If you are <strong>{personName}</strong>, please enter your <b>{validationType}</b> to continue.</p>

        {isStaff ? <>
            <p>You should use the postcode for your address that is registered with Guy’s and St Thomas’. If you have moved house and not told us you may need to enter the postcode of your previous address.</p>

            <p>If you do not know your postcode please check the Electronic Staff Record or speak to your manager who can check it for you.</p>
            <p>(Please ensure ESR has your up to date details.)</p>

            
        </> : <>
            {validationType === 'postcode' && <>
                <p>You should use the postcode for your address that is registered with Guy's and St Thomas' or your GP. If you have moved house and not told us you may need to enter the postcode of your previous address.</p>
                <p>If you do not know your postcode please telephone <a href="tel:020 7188 4040">020 7188 4040</a>.</p>
            </>}
            {validationType === 'surname' && <>
                <p>You should use your last name for verification.</p>
                <p>If you cannot proceed past this screen please call <a href="tel:020 7188 4040">020 7188 4040</a>.</p>
            </>}
        </>
        }

        <InputGroup>
            <Input placeholder={validationType === 'postcode' ? "Registered Postcode" : "Surname"} value={tempPostCode} onChange={(e) => setTempPostCode(e.target.value)} maxLength="10"></Input>
            <br /><br />
            <Button color="success" block onClick={() => submitPostCode(tempPostCode)}>Submit</Button>
        </InputGroup>

        <small>Please <strong>close</strong> this page if you are not <strong>{personName}</strong>.  </small>
    </div>
}